<template>
    <!--shop  area start-->
    <div class="shop_area shop_reverse pt-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-12">
                   <!--sidebar widget start-->
                     <aside class="sidebar_widget only-desktop">
                        <div class="widget_inner">
                            <!-- <div class="widget_list widget_filter">
                                <h2>Tìm theo giá</h2>
                                <form action="#"> 
                                    <div id="slider-range"></div>   
                                    <button type="submit">Filter</button>
                                    <input type="text" name="text" id="amount" />
                                </form> 
                            </div> -->
                            <div class="widget_list widget_categories">
                                <h2>Danh mục sản phẩm</h2>
                                <ul>
                                    <li v-for="cat in categories" :key="cat.id" v-on:click="onCheckCat(cat)">
                                        <input type="checkbox" v-model="cat.checked">
                                        <a href="javascript:void(0)">{{cat.name}}</a> 
                                        <span class="checkmark"></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- <div class="single_banner">
                            <a href="#"><img src="assets/img/banner.jpg" alt=""></a>
                        </div> -->
                    </aside>
                    <!--sidebar widget end-->
                </div>
                <div class="col-lg-9 col-md-12">
                    <product-list :page_size="40" :list_category="selectedCategories" title="Danh sách sản phẩm" v-if="!product_makeup"></product-list>
                    <product-makeup :page_size="40" :list_category="selectedCategories" title="Khoá học trang điểm" v-else></product-makeup>
                </div>
            </div>
        </div>
    </div>
    <!--shop  area end-->
</template>
<script>
import ProductList from "@/components/ProductList.vue";
import ProductMU from "@/components/ProductMU.vue";
import { mapState } from "vuex";
import configs from '@/configs'
import _ from 'lodash';
export default {
    components: {
        'product-list': ProductList,
        'product-makeup': ProductMU,
    },
    data() {
        return {
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: [],
            selectedCategories: [],
            cat: ''
        }
    },
    watch: {
        categories() {
            this.cat = Number(this.search_params ? this.search_params.cat : '');
            if(this.cat > 0) {
                let selected_cat = _.find(this.categories, {'id': Number(this.cat)});
                selected_cat.checked = true;
                this.selectedCategories = _.filter(this.categories, {'checked': true});
            }
        },
    },
    computed: {
        ...mapState({
            categories: state => state.categories.all.data,
            loading: state => state.products.loading
        }),
        isAuthenticated() {
            return localStorage.getItem('jwt') !== null;
        },
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        product_makeup() {
            return this.$route.path.includes('khoa-hoc-trang-diem');
        },
        search_params() {
            return this.$route.query;
        },
    },
    methods: {
        onCheckCat(item) {
            item.checked = !item.checked;
            this.selectedCategories = _.filter(this.categories, {'checked': true});
        }
    },
    mounted() {
        this.$store.dispatch("categories/getList");
        this.$root.$emit('COMPONENT_LOADED');
    }
}
</script>